export default "/EncodeSans-Regular.a13f7934-ac56a3.ttf";